(() => {
  'use strict';

  const MARKERS = [
    'inkmerge dynamic shirt preview',
    'inkmerge comfort colors shirt preview'
  ];

  const COLORS = {
    ivory: '#eee2c4',
    bay: '#9db8ad',
    berry: '#8f4b75',
    blossom: '#f3a9c9',
    'blue jean': '#6b84a3',
    chambray: '#b9d8ea',
    'flo blue': '#5977c8',
    graphite: '#34333a',
    moss: '#4f6453',
    orchid: '#cbb2d9',
    pepper: '#393b3b',
    violet: '#8370be',
    watermelon: '#ee5366',
    yam: '#b6603d',
    black: '#111111'
  };

  const SHIRT_SVG = `
    <svg class="im-dynamic-shirt-preview__shirt" viewBox="0 0 600 520" role="img" aria-label="T-shirt preview">
      <defs>
        <linearGradient id="im-shirt-shade" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#ffffff" stop-opacity=".5"/>
          <stop offset=".46" stop-color="#ffffff" stop-opacity="0"/>
          <stop offset="1" stop-color="#000000" stop-opacity=".55"/>
        </linearGradient>
        <filter id="im-shirt-soft" x="-10%" y="-10%" width="120%" height="120%">
          <feGaussianBlur stdDeviation="1.1"/>
        </filter>
      </defs>
      <path class="im-dynamic-shirt-preview__fabric" d="M207 57c24 27 54 40 93 40s69-13 93-40l92 51 72 114-83 52-38-55v244H164V219l-38 55-83-52 72-114 92-51Z"/>
      <path d="M232 63c9 31 31 47 68 47s59-16 68-47c-15-9-27-15-39-19-7 17-16 25-29 25s-22-8-29-25c-12 4-24 10-39 19Z" fill="rgba(15,17,23,.20)"/>
      <path class="im-dynamic-shirt-preview__shade" d="M207 57c24 27 54 40 93 40s69-13 93-40l92 51 72 114-83 52-38-55v244H164V219l-38 55-83-52 72-114 92-51Z" fill="url(#im-shirt-shade)" filter="url(#im-shirt-soft)"/>
      <path d="M165 459h271" stroke="rgba(15,17,23,.2)" stroke-width="3"/>
      <path d="M165 218c18 10 31 15 39 15M436 218c-18 10-31 15-39 15" stroke="rgba(15,17,23,.14)" stroke-width="3" fill="none"/>
    </svg>`;

  function isMarkedImage(img) {
    const alt = (img.getAttribute('alt') || '').toLowerCase();
    return MARKERS.some(marker => alt.includes(marker));
  }

  function contextClass(img) {
    if (img.closest('.pdp-grid__media, .pdp-gallery, [data-pdp-gallery]')) {
      return ' im-dynamic-shirt-preview--pdp';
    }
    if (img.closest('.card__img, .card__img--container, [data-product-card-default]')) {
      return ' im-dynamic-shirt-preview--card';
    }
    return '';
  }

  function buildPreview(img) {
    if (!img || img.closest('.im-dynamic-shirt-preview') || !isMarkedImage(img)) return;

    const host = document.createElement('div');
    host.className = `im-dynamic-shirt-preview${contextClass(img)}`;
    host.dataset.shirtColor = 'ivory';
    host.style.setProperty('--im-shirt-color', COLORS.ivory);

    const art = document.createElement('div');
    art.className = 'im-dynamic-shirt-preview__art';

    const notice = document.createElement('span');
    notice.className = 'im-dynamic-shirt-preview__notice';
    notice.textContent = 'Artwork preview · placement reviewed before print';

    const parent = img.parentNode;
    if (!parent) return;

    parent.insertBefore(host, img);
    host.insertAdjacentHTML('afterbegin', SHIRT_SVG);
    host.appendChild(art);
    art.appendChild(img);
    host.appendChild(notice);
  }

  function hydrate(root = document) {
    root.querySelectorAll('img').forEach(buildPreview);
  }

  function setPreviewColor(value) {
    if (!value) return;
    const key = value.trim().toLowerCase();
    const color = COLORS[key];
    if (!color) return;

    document.querySelectorAll('.im-dynamic-shirt-preview--pdp').forEach(preview => {
      preview.dataset.shirtColor = key.replace(/\s+/g, '-');
      preview.style.setProperty('--im-shirt-color', color);
    });
  }

  document.addEventListener('click', event => {
    const option = event.target.closest('[data-option-value]');
    if (!option) return;
    const optionIndex = option.getAttribute('data-option-index');
    if (optionIndex && optionIndex !== '1') return;
    setPreviewColor(option.getAttribute('data-option-value'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate());
  } else {
    hydrate();
  }

  const observer = new MutationObserver(records => {
    records.forEach(record => {
      record.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches('img')) buildPreview(node);
        hydrate(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
